<template>
  <Menu
    as="div"
    class="relative inline-block text-left"
  >
    <div class="flex">
      <MenuButton
        :class="$cn('inline-flex w-full items-center justify-center space-x-2 rounded-md align-top text-sm font-medium focus:outline-none', ui?.label)"
      >
        <span>
          <slot name="label">{{ label }}</slot>
        </span>
        <Icon
          icon="chevron-down"
          class="pointer-events-none h-5 text-xs text-supplement"
          aria-hidden="true"
        />
      </MenuButton>
    </div>

    <transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-in"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0"
      @after-enter="$emit('toggle', true)"
      @after-leave="$emit('toggle', false)"
    >
      <MenuItems
        :class="
          $cn(
            'absolute z-50 mt-2 w-56 divide-y divide-gray-200 rounded-md bg-white shadow-lg ring-1 ring-gray-200 focus:outline-none',
            {
              'right-0 origin-top-right': position === 'right',
              'left-0 origin-top-left': position === 'left'
            },
            ui?.items
          )
        "
      >
        <slot />
      </MenuItems>
    </transition>
  </Menu>
</template>

<script setup lang="ts">
import { Menu, MenuButton, MenuItems } from '@headlessui/vue'
import type { ClassValue } from 'clsx'

withDefaults(
  defineProps<{
    label?: string
    position?: 'left' | 'right'
    ui?: Partial<{
      label: ClassValue
      items: ClassValue
    }>
  }>(),
  {
    label: 'Options',
    position: 'left',
    ui: undefined
  }
)

defineEmits<{
  toggle: [isOpen: boolean]
}>()
</script>

<style>
.dropdown {
  &--button {
    @apply border px-4 py-3;
  }
}
</style>
